// export const SERVER_URL = "http://192.168.2.166:3000/api/user/v1";
// export const SERVER_URL = "http://127.0.0.1:3000/api/user/v1";
// export const SERVER_URL = "http://192.168.2.125:3000/api/user/v1";
// export const SERVER_URL = "http://192.168.1.101:3000/api/user/v1";

export const SERVER_URL = "https://api.fastcrm.ir/api/user/v1";
